import LessonContent from './component'
export default LessonContent
